import {Banner} from '@primer/react'

interface ServerErrorFormBannerProps extends React.PropsWithChildren {
  ref?: React.Ref<HTMLDivElement>
}

export function ServerErrorFormBanner({children, ref}: ServerErrorFormBannerProps) {
  return (
    <Banner
      title="Server error"
      hideTitle
      variant="critical"
      data-testid="server-error-banner"
      ref={ref}
      tabIndex={0}
      description={children}
    />
  )
}

try{ ServerErrorFormBanner.displayName ||= 'ServerErrorFormBanner' } catch {}